import api from "../../../Api";
import { BaseService } from "../../../BaseService";

const URL = "plans/agents/categories";

export class PlanAgentsCategoriesService extends BaseService {
  async list(params: any): Promise<any[]> {
    try {
      return this.handleResponse(await api.post(`${URL}/list`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }

  async fetch(params: any): Promise<any> {
    try {
      return this.handleResponse(await api.post(`${URL}/update`, params));
    } catch (e: any) {
      return this.catchHandler(e);
    }
  }
}
